import { colors, hexToRgba } from "@/styles/theme";
import { Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useRef } from "react";
import CookieConsent from "react-cookie-consent";
import { motion } from "framer-motion";

export const CookiesConsent = () => {
  const t = useTranslations("cookiesConsent");
  const ref = useRef(null);

  const acceptBtnStyles = {
    backgroundColor: "transparent",
    color: colors.brand[1000],
    fontWeight: "bold",
  };

  const containerStyle = {
    backgroundColor: colors.brand[100],
    color: colors.brand[1000],
    fontSize: "14px",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    boxShadow: `0px 0px 10px ${hexToRgba(colors.brand[1000], 0.2)}`,
  };

  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.5 }}
      variants={variants}
    >
      <CookieConsent
        location="bottom"
        buttonText="OK"
        cookieName="cookieConsentResult"
        style={containerStyle}
        buttonStyle={acceptBtnStyles}
        expires={150}
        ref={ref}
      >
        <Stack spacing={6}>
          <Heading as="p" size="sm" fontFamily="Gotham">
            {t("title")}
          </Heading>

          <Text
            dangerouslySetInnerHTML={{
              __html: t.raw("description"),
            }}
          ></Text>
        </Stack>
      </CookieConsent>
    </motion.div>
  );
};
